<template>
	<div class='knd-modal' >
    <div class="pane-wrapper">
      <div class="content pane-wrapper knd-wrapper">
        <div class="subtitles-container" ref="subtitlescontainer">
          <span 
            v-for="(subtitle, index) in syncData" 
            :key="'modal-' + index"
            :id="'c-' + index"
            :class="{active: currentIndex >= index}"
            >
            {{ subtitle.part }}
          </span>
        </div>
      </div>
  </div>
	</div>
</template>

<script>

import { useStore } from 'vuex'
import { ref, onMounted, watch, computed } from 'vue';
import { CupertinoPane, CupertinoSettings } from 'cupertino-pane';

export default {
  setup () {
    const store = useStore()
    const ASSETS = ref(process.env.VUE_APP_ASSETS);

    let paneModal;
    let syncData = ref([]);

    watch( () => store.state.showModal, (newVal, oldVal)=> {
      if(newVal) {
        presentModal();
        syncData.value = store.state.modalData;
      }
    });


    onMounted(() => {
      initModal();
    })

    const initModal = () => {
      paneModal = new CupertinoPane('.knd-modal', { 
        modal:true,
        backdrop: true,
        events: {
          onBackdropTap: () => dismissModal()
        }
      });

      paneModal.on('onWillDismiss', () => {
        store.dispatch('dismissModal');
        document.body.classList.remove("has-modal");
			})
    }

    function presentModal() {
      paneModal.present({animate: true});
      document.body.classList.add("has-modal");
    }

    function dismissModal() {
      paneModal.destroy({animate: true});
    }

    return {
      modalData: computed(() => store.getters.modalData),
      ASSETS,
      syncData
    }
  }
}
</script>


<style lang="scss">
.cupertino-pane-wrapper {
  z-index: 10000;
}

.cupertino-pane-wrapper .pane {
  --cupertino-pane-background: linear-gradient(175.47deg, #E1E1E1 -1.02%, #E1E1E1 70.98%, #A7AAA8 129.27%);

  max-height: 70vh;
  overflow:scroll;

  @include md { 
    max-width: 90%;

  }

  .pane-wrapper {
    margin: 0 auto;      
    max-width: 650px;
    padding: 1em 1em 2em;
  }

  .subtitles-container {
    span {
      display: block;
    }
  }
}

</style>